import AffordabilityShow from "./AffordabilityShow";

const Aff = { show: AffordabilityShow };

export default Aff;
